"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-pietro-apostolo": {
    "c3754458": [{
      "hkey": "886dedb2",
      "slug": "zeta",
      "name": "Zeta",
      "primary": true,
      "skipSearch": false
    }],
    "bivio-zeta": [{
      "hkey": "886dedb2",
      "slug": "zeta",
      "name": "Zeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;